/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconLogin = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M.75 12.004H16.5M12.75 15.754l3.75-3.75-3.75-3.75" />
        <path d="M3.306 16.6c2.538 5.214 8.822 7.383 14.036 4.845s7.383-8.822 4.845-14.036S13.365.025 8.151 2.564a10.5 10.5 0 0 0-4.666 4.494" />
      </g>
    </svg>
  ),
);
